import { Store } from '@ngxs/store';
import { MembershipItem, MembershipRegistrationResponse, RegistrationFormType } from '@common/membership/shared';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export var MembershipRegistrationMode = /*#__PURE__*/function (MembershipRegistrationMode) {
  MembershipRegistrationMode["create"] = "create";
  MembershipRegistrationMode["completePayment"] = "completePayment";
  // registered mode will be used in two scenarios:
  // users with expired memberships -- users with account but no membership at all 
  // (this is an edge case for pflegetheke, as registration is only possible through creating a membership)
  MembershipRegistrationMode["registered"] = "registered";
  return MembershipRegistrationMode;
}(MembershipRegistrationMode || {});
export var MembershipDisplayMode = /*#__PURE__*/function (MembershipDisplayMode) {
  MembershipDisplayMode["full"] = "full";
  MembershipDisplayMode["compact"] = "compact";
  return MembershipDisplayMode;
}(MembershipDisplayMode || {});
export var MembershipRegistrationActions;
(function (MembershipRegistrationActions) {
  let SetRegistrationMode = /*#__PURE__*/(() => {
    class SetRegistrationMode {
      static {
        this.type = '[MembershipRegistration] SetRegistrationMode';
      }
      constructor(mode) {
        this.mode = mode;
      }
    }
    return SetRegistrationMode;
  })();
  MembershipRegistrationActions.SetRegistrationMode = SetRegistrationMode;
  let SetDisplayMode = /*#__PURE__*/(() => {
    class SetDisplayMode {
      static {
        this.type = '[MembershipRegistration] SetDisplayMode';
      }
      constructor(mode) {
        this.mode = mode;
      }
    }
    return SetDisplayMode;
  })();
  MembershipRegistrationActions.SetDisplayMode = SetDisplayMode;
  let RestoreExistingMembership = /*#__PURE__*/(() => {
    class RestoreExistingMembership {
      static {
        this.type = '[MembershipRegistration] RestoreExistingMembership';
      }
      constructor(membership, registrationData) {
        this.membership = membership;
        this.registrationData = registrationData;
      }
    }
    return RestoreExistingMembership;
  })();
  MembershipRegistrationActions.RestoreExistingMembership = RestoreExistingMembership;
  let SetEnabledSteps = /*#__PURE__*/(() => {
    class SetEnabledSteps {
      static {
        this.type = '[MembershipRegistration] SetEnabledSteps';
      }
      constructor(steps) {
        this.steps = steps;
      }
    }
    return SetEnabledSteps;
  })();
  MembershipRegistrationActions.SetEnabledSteps = SetEnabledSteps;
  let GoToStep = /*#__PURE__*/(() => {
    class GoToStep {
      static {
        this.type = '[MembershipRegistration] GoToStep';
      }
      constructor(name) {
        this.name = name;
      }
    }
    return GoToStep;
  })();
  MembershipRegistrationActions.GoToStep = GoToStep;
  let ConfirmStep = /*#__PURE__*/(() => {
    class ConfirmStep {
      static {
        this.type = '[MembershipRegistration] ConfirmStep';
      }
      // completedStep can be used to complete not <current> but a specific step.
      constructor(completedStep) {
        this.completedStep = completedStep;
      }
    }
    return ConfirmStep;
  })();
  MembershipRegistrationActions.ConfirmStep = ConfirmStep;
  let SetPluginFormState = /*#__PURE__*/(() => {
    class SetPluginFormState {
      static {
        this.type = '[MembershipRegistration] setPluginFormState';
      }
      // state contents are only known to plugin, so type is any here
      constructor(state) {
        this.state = state;
      }
    }
    return SetPluginFormState;
  })();
  MembershipRegistrationActions.SetPluginFormState = SetPluginFormState;
  let SetFormData = /*#__PURE__*/(() => {
    class SetFormData {
      static {
        this.type = '[MembershipRegistration] SetFormData';
      }
      constructor(data, formType) {
        this.data = data;
        this.formType = formType;
      }
    }
    return SetFormData;
  })();
  MembershipRegistrationActions.SetFormData = SetFormData;
  let SetMembershipType = /*#__PURE__*/(() => {
    class SetMembershipType {
      static {
        this.type = '[MembershipRegistration] SetMembershipType';
      }
      constructor(ref) {
        this.ref = ref;
      }
    }
    return SetMembershipType;
  })();
  MembershipRegistrationActions.SetMembershipType = SetMembershipType;
  let SetCareDegree = /*#__PURE__*/(() => {
    class SetCareDegree {
      static {
        this.type = '[MembershipRegistration] SetCareDegree';
      }
      constructor(hasCareDegree) {
        this.hasCareDegree = hasCareDegree;
      }
    }
    return SetCareDegree;
  })();
  MembershipRegistrationActions.SetCareDegree = SetCareDegree;
  let Submit = /*#__PURE__*/(() => {
    class Submit {
      static {
        this.type = '[MembershipRegistration] Submit';
      }
      constructor() {}
    }
    return Submit;
  })();
  MembershipRegistrationActions.Submit = Submit;
  let SubmitCompleted = /*#__PURE__*/(() => {
    class SubmitCompleted {
      static {
        this.type = '[MembershipRegistration] SubmitCompleted';
      }
      constructor(response, error) {
        this.response = response;
        this.error = error;
      }
    }
    return SubmitCompleted;
  })();
  MembershipRegistrationActions.SubmitCompleted = SubmitCompleted;
  let SetPaypalOrderId = /*#__PURE__*/(() => {
    class SetPaypalOrderId {
      static {
        this.type = '[MembershipRegistration] SetPaypalOrderId';
      }
      constructor(orderId) {
        this.orderId = orderId;
      }
    }
    return SetPaypalOrderId;
  })();
  MembershipRegistrationActions.SetPaypalOrderId = SetPaypalOrderId;
  let CompletePaypalOrder = /*#__PURE__*/(() => {
    class CompletePaypalOrder {
      static {
        this.type = '[MembershipRegistration] CompletePaypalOrder';
      }
      constructor(data) {
        this.data = data;
      }
    }
    return CompletePaypalOrder;
  })();
  MembershipRegistrationActions.CompletePaypalOrder = CompletePaypalOrder;
  let Reset = /*#__PURE__*/(() => {
    class Reset {
      static {
        this.type = '[MembershipRegistration] Reset';
      }
      constructor() {}
    }
    return Reset;
  })();
  MembershipRegistrationActions.Reset = Reset;
})(MembershipRegistrationActions || (MembershipRegistrationActions = {}));
export let MembershipRegistrationFacade = /*#__PURE__*/(() => {
  class MembershipRegistrationFacade {
    constructor(store) {
      this.store = store;
    }
    setRegistrationMode(mode) {
      return this.store.dispatch(new MembershipRegistrationActions.SetRegistrationMode(mode));
    }
    setDisplayMode(mode) {
      return this.store.dispatch(new MembershipRegistrationActions.SetDisplayMode(mode));
    }
    confirmStep(completedStep) {
      return this.store.dispatch(new MembershipRegistrationActions.ConfirmStep(completedStep));
    }
    goToStep(name) {
      return this.store.dispatch(new MembershipRegistrationActions.GoToStep(name));
    }
    setPluginFormState(state) {
      return this.store.dispatch(new MembershipRegistrationActions.SetPluginFormState(state));
    }
    setFormData(data, formType) {
      return this.store.dispatch(new MembershipRegistrationActions.SetFormData(data, formType));
    }
    setMembershipType(ref) {
      return this.store.dispatch(new MembershipRegistrationActions.SetMembershipType(ref));
    }
    setCareDegree(hasCareDegree) {
      return this.store.dispatch(new MembershipRegistrationActions.SetCareDegree(hasCareDegree));
    }
    submit() {
      return this.store.dispatch(new MembershipRegistrationActions.Submit());
    }
    reset() {
      return this.store.dispatch(new MembershipRegistrationActions.Reset());
    }
    static {
      this.ɵfac = function MembershipRegistrationFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipRegistrationFacade)(i0.ɵɵinject(i1.Store));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MembershipRegistrationFacade,
        factory: MembershipRegistrationFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MembershipRegistrationFacade;
})();